/**
 * @file: useDeliveryCheckCache.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { DeliveryCheckManagerBase } from '@euler/app/flows/task/functions/task-detail/delivery-check/DeliveryCheckManagerBase';
import { onErrorIgnore, withConfirmation } from '@euler/utils';
import { usePersistFn } from '@euler/utils/hooks';
import { useEffect } from 'react';

export const useDeliveryCheckCache = (manager: DeliveryCheckManagerBase) => {
  const tryLoadCached = usePersistFn(() => {
    manager
      .loadCached()
      .then(async cached => {
        if (cached == null) {
          return;
        }
        const shouldApplyCached = await withConfirmation({
          title: '确认',
          message: '存在已录入的缓存数据，是否加载?',
          confirmButtonText: '立即加载',
          cancelButtonText: '忽略',
        });
        if (shouldApplyCached) {
          manager.applyCached(cached);
        } else {
          await manager.discardCache();
        }
      })
      .catch(onErrorIgnore);
  });

  useEffect(() => {
    tryLoadCached();
  }, [tryLoadCached]);
};
